
export const DefaultButtons = [
  { id: 1, class: 'primary', text: ' Primary' },
  { id: 2, class: 'secondary', text: '  Secondary' },
  { id: 3, class: 'success', text: ' Success' },
  { id: 4, class: 'danger', text: '  Danger' },
  { id: 5, class: 'warning', text: '  Warning' },
  { id: 6, class: 'info', text: 'Info' },
  { id: 7, class: 'light', text: ' Light' },
  { id: 8, class: 'dark', text: '  Dark' },
  { id: 9, class: 'link', text: 'Link' },
];
// Light Buttons//

export const LightButtons = [
  { id: 1, class: 'primary-light', text: ' Primary' },
  { id: 2, class: 'secondary-light', text: '  Secondary' },
  { id: 3, class: 'success-light', text: ' Success' },
  { id: 4, class: 'danger-light', text: '  Danger' },
  { id: 5, class: 'warning-light', text: '  Warning' },
  { id: 6, class: 'info-light', text: 'Info' },
  { id: 7, class: 'purple-light', text: ' purple' },
  { id: 8, class: 'teal-light', text: '  teal' },
  { id: 9, class: 'orange-light', text: 'orange' },
];

export const OutlineButtons = [
  { id: 1, class: 'outline-primary', text: ' Primary' },
  { id: 2, class: 'outline-secondary', text: '  Secondary' },
  { id: 3, class: 'outline-success', text: ' Success' },
  { id: 4, class: 'outline-danger', text: '  Danger' },
  { id: 5, class: 'outline-warning', text: '  Warning' },
  { id: 6, class: 'outline-info', text: 'Info' },
  { id: 7, class: 'outline-light', text: ' Light' },
  { id: 8, class: 'outline-dark', text: '  Dark' },
];

export const GradientButtons = [
  { id: 1, class: 'primary-gradient', text: 'Primary' },
  { id: 2, class: 'secondary-gradient', text: 'Secondary' },
  { id: 3, class: 'success-gradient', text: 'Success' },
  { id: 4, class: 'danger-gradient', text: 'Danger' },
  { id: 5, class: 'warning-gradient', text: 'Warning' },
  { id: 6, class: 'info-gradient', text: 'Info' },
  { id: 7, class: 'orange-gradient', text: ' Orange' },
  { id: 8, class: 'purple-gradient', text: 'Purple' },
  { id: 8, class: 'teal-gradient', text: '  teal' },
];

export const GhostButtons = [
  { id: 1, class: 'primary-ghost', text: 'Primary' },
  { id: 2, class: 'secondary-ghost', text: 'Secondary' },
  { id: 3, class: 'success-ghost', text: 'Success' },
  { id: 4, class: 'danger-ghost', text: 'Danger' },
  { id: 5, class: 'warning-ghost', text: 'Warning' },
  { id: 6, class: 'info-ghost', text: 'Info' },
  { id: 7, class: 'orange-ghost', text: ' Orange' },
  { id: 8, class: 'purple-ghost', text: 'Purple' },
  { id: 8, class: 'teal-ghost', text: '  teal' },
];


export const SocialIconButtons = [
  { id: 1, class: 'facebook', icon: 'facebook-line' },
  { id: 2, class: 'twitter', icon: 'twitter-x-line' },
  { id: 3, class: 'instagram', icon: 'instagram-line' },
  { id: 4, class: 'github', icon: 'github-line' },
  { id: 5, class: 'youtube', icon: 'youtube-line' },
  { id: 5, class: 'google', icon: 'google-line' },

];

export const ColoredButtons = [
  { id: 1, class: 'primary' },
  { id: 2, class: 'secondary' },
  { id: 3, class: 'success' },
  { id: 4, class: 'info' },
  { id: 5, class: 'warning' },
  { id: 6, class: 'danger' },
  { id: 6, class: 'purple' },
  { id: 6, class: 'orange' },

];

export const LabelButtons = [
  { id: 1, color: 'primary', class: 'chat-smile' },
  { id: 2, color: 'secondary', class: 'settings-4' },
  { id: 3, color: 'warning', class: 'spam-2' },
  { id: 4, color: 'info', class: 'phone' },
  { id: 5, color: 'success', class: 'thumb-up' },
  { id: 6, color: 'danger', class: 'close' },

];

